<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <InventoryReceipt v-if='selectedIndex === 0' />
  </div>
</template>

<script>
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import InventoryReceipt from './InventoryReceipt.vue'

export default {
  name: 'inventory-receipt-tab',
  data: function () {
    return {
      userInfo: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '자재입출현황'
        }
      ]
    }
  },
  components: {
    DxTabPanel,
    InventoryReceipt
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {

  }

}
</script>

<style lang="scss">

</style>
